module.exports = __webpack_public_path__ + "public/Icons/MapMarker/destinationMarker.png?ba3a5b99";